/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Component, OnInit } from '@angular/core';
import { DescargaService } from './../_services/descargas.service';
import { DescargaRespuesta } from './../_models/descargas';

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.css']
})
export class BalanceComponent implements OnInit {

  respuesta: DescargaRespuesta;

  constructor(private service: DescargaService) {
    this.respuesta = new DescargaRespuesta();
  }

  ngOnInit() {
    this.service.getAll('files-balance').subscribe(
      datos => {
        this.respuesta = datos;
      }
    );
  }

}
